type GetConditionalClassNameParams = {
  idx: number;
  actionsLength: number;
  disabled?: boolean;
};

export const getTriggerClassName = ({
  idx,
  actionsLength,
  disabled
}: GetConditionalClassNameParams): string => {
  const isFirst = idx === 0;
  const isLast = actionsLength - 1 === idx;
  return [
    disabled
      ? "cursor-not-allowed text-content-400 bg-alpha-40 hover:bg-alpha-80"
      : "hover:bg-alpha-40",
    isFirst && "rounded-t-md",
    isLast && "rounded-b-md border-b-0"
  ]
    .filter(Boolean)
    .join(" ");
};
